import Lottie from 'lottie-react';
import chatMentionsTodo from '../jsons/chat-empty.json';

const ChatMentionsTodo = props => {
  return <Lottie loop={false} animationData={chatMentionsTodo} {...props} />;
};

export default ChatMentionsTodo;
